import { Component, Input, OnInit } from '@angular/core';
import { BreakpointService } from '../../../../services/breakpoints';
import { Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-section-wrapper',
  templateUrl: './section-wrapper.component.html',
})
export class SectionWrapperComponent implements OnInit {
  @Input() wrapperCssClass: string = '';
  @Input() titleText!: string;
  @Input() titleId: string | null = 'section-title';
  @Input() titleLimitedWidth: boolean = false;
  @Input() customTitleClass: string = '';

  isDesktop$!: Observable<boolean>;

  constructor(private readonly breakpointService: BreakpointService) {}

  ngOnInit() {
    this.isDesktop$ = this.breakpointService.isMatchingBreakpoint(Breakpoints.Web);
  }
}
